import type { RouteRecordRaw } from 'vue-router';
import { buildRootURL } from '@centric-os/helpers';
import { AgentRoutePathNames, AgentRouteNames } from './enums';

const Component = () => import('./components/AgentChatPage.vue');

export * from './enums';

export const route: RouteRecordRaw = {
  path: buildRootURL(AgentRoutePathNames.AGENT),
  name: AgentRouteNames.AGENT,
  meta: {
    title: 'Assistant',
    requireAuth: true,
  },
  component: Component,
};
